module.exports = __webpack_public_path__ + "static/media/tree_13.03db0786.jpg";